// extracted by mini-css-extract-plugin
export var backdropBlur = "_le-0";
export var contentCard = "_le-5";
export var frame = "_le-2";
export var image = "_le-4";
export var imagePane = "_le-3";
export var modal = "_le-1";